import { useCurrentOrderQuery } from '@/hooks/queries/use-order-query';
import { formatMobileNumber } from '@/utils/Utils';

type CustomerInformationDisplayProps = { onEdit: () => void };

export default function CustomerInformationDisplay({ onEdit }: CustomerInformationDisplayProps) {
  const { data: order, isLoading } = useCurrentOrderQuery();

  if (isLoading) return 'Loading';

  if (!order || !order.customer || !order.shippingAddress) {
    throw new Error('Invalid state: No current order or order customer');
  }

  return (
    <div className="flex flex-col gap-1">
      <button onClick={onEdit} className="absolute right-4 top-4 text-violet-500">
        Ändra
      </button>
      <div>
        {order.customer.firstName} {order.customer.lastName}
      </div>
      <div>
        {order.shippingAddress.street}, {order.shippingAddress.postalCode} {order.shippingAddress.city}
      </div>
      <div>
        {order.customer.email}, {formatMobileNumber(order.customer.mobileNumber)}
      </div>
    </div>
  );
}
